import { EChartsOption } from 'echarts';

export const ENERGY_CHART_KEY_PREFIX = 'energy:' as const;

export type BaseChartKey = 'eff' | 'sca' | 'str' | 'wka' | 'imb' | 'speedup' | 'loss' | 'perf';
export type EnergyChartKey = `${typeof ENERGY_CHART_KEY_PREFIX}${string}`;
export type ChartKey = BaseChartKey | EnergyChartKey;

export function buildEnergyChartKey(sensorName: string): EnergyChartKey {
  return `${ENERGY_CHART_KEY_PREFIX}${sensorName}` as EnergyChartKey;
}

export function isEnergyChartKey(key: string): key is EnergyChartKey {
  return key.startsWith(ENERGY_CHART_KEY_PREFIX);
}

export function getEnergySensorName(key: EnergyChartKey): string {
  return key.slice(ENERGY_CHART_KEY_PREFIX.length);
}

export interface RegionMetrics {
  executionRange: [number, number];
  timeVariationRange: [number, number];
}

export interface RegionDetails {
  filename: string;
  lines: string;
}

export interface ChartDefinition {
  key: ChartKey;
  title: string;
  palette: string[];
  min: number;
  max: number;
  unit: string;
}

export interface ComparisonChartOptions {
  normal: EChartsOption | null;
  smoothed: EChartsOption | null;
  relative: EChartsOption | null;
  relativeSmoothed: EChartsOption | null;
}

export interface ComparisonRegionData {
  regionId: string;
  options: ComparisonChartOptions;
}

export interface ComparisonChart {
  key: ChartKey;
  title: string;
  regionData: ComparisonRegionData[];
  showSmoothed: boolean;
  showRelative: boolean;
  showEDP: boolean;
}
